<template>
  <div class="two-column-view">
    <div class="left-side-column">
      <div class="column-image">
        <img src="../../assets/about.png" alt="About" />
      </div>
      <DownloadApp />
    </div>
    <div class="article-content">
      <h1>关于Goldenlink+</h1>
      <p>
        GoldenLink+，又称GOLD，是一个集实时音频社交媒体、NFT福利和AI商业智能匹配于一体的营销平台。
      </p>
      <p>我们的业务生态系统模式如下：</p>
      <h5>1. 连接</h5>
      <p>
        推荐代码将您的所有联系人联系起来，形成您自己的销售网络，并与您的奖励算法绑定。您的人脉越广，您的团队或网络越强大，您获得直接和间接奖励的机会就越多。
      </p>
      <h5>2. 市场营销</h5>
      <p>
        <strong>开房间</strong
        >：创建活动来扩大产品、服务和品牌的受众；继续提高影响力；获得更多的追随者和受众；提供更多机会来扩大目标社交媒体流量。
      </p>
      <p>
        <strong>转换盈利</strong>：实现2WR双向奖励：佣金 + 代币<br />创建您的专属社区：
        不断扩大自己的影响力，用社群的力量为自己的目标赋能，促进目标的营销转化。
      </p>
      <p>
        <strong>GSG证书</strong>：GOLD将分阶段发放总计20,000个GSG（Gold Striker
        Gold）会员资格。与GSR（Gold Striker Regular）不同，该资格允许 GSG
        通过其网络发展推荐企业加入GOLD应用程序，从而成为全球独家营销代理（The
        Global Exclusive Marketing Agent）： GEMA，与该企业的 ID 相关联。
      </p>
      <p>
        <strong>GEMA证书</strong
        >：只要与在GOLD平台上产生的营销转化相关，就可以涵盖直接或间接奖励，从您自己的人脉关系扩展到更广泛的利益。
      </p>
      <p>
        <strong>NFT代币拍卖</strong
        >：在GSG和GEMA证书的早期阶段，由于其限量发行的性质，GOLD将发行不同样式的NFT代币，让您的资产权利有机会升值。即使通过Web
        3
        NFT代币交易平台上的拍卖，原始证书持有者也有机会绑定NFT进行转让和出售。请继续关注未来的信息发布，我们将提供详细的操作方法。
      </p>
      <p>
        <strong>NFT Protocol</strong
        >：选择协议和发行链非常重要，比如使用Rone协议为比特币生态系统赋能。<br />流量挖矿：
        获得双向奖励（2WR），佣金变现（APP版），+代币盯盘（网页版）。
      </p>
    </div>
  </div>
</template>

<script>
import DownloadApp from "@/components/DownloadApp.vue";

export default {
  components: {
    DownloadApp,
  },
};
</script>

<style scoped></style>
